import Ribbon from "../Ribbon/Ribbon"


const GuideItem = ({ guideItem }) => {
    // console.log('guideItem in guideItem', guideItem)
    const imageSrc = guideItem.guideItemImageSrc
    const imageAlt = guideItem.guideItemImageAlt
    const link = guideItem.guideItemLink
    const title = guideItem.guideItemTitle
    const CTA = guideItem.guideItemCTA

    return (
        <div className="guide-item-outer">

                <div className="guide-item-inner">
                    <div className="guide-item-ribbon">
                    <Ribbon />
                    </div>
                    <div className="guide-item-image">
                        <a href={link} target="_blank" rel="noopener noreferrer">
                            <img src={imageSrc} alt={imageAlt} />
                        </a>
                    </div>
                    <div className="guide-item-content">
                        <h3 className="guide-item-title">{title}</h3>
                        <div className="guide-item-link">
                            <a href={link} target="_blank" rel="noopener noreferrer">{CTA}</a>
                        </div>
                    </div>
                </div>

        </div>
    )
}

export default GuideItem
